
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { useRoute } from "vue-router";
const TencentMap = (window as any).TMap;
import { DataType } from "./ShowMapType";

const stateData: DataType = {
  latitude: "",
  longitude: "",
  locationName: "123",
};

export default defineComponent({
  setup(props) {
    const state = reactive<DataType>(stateData);
    const route = useRoute();
    state.longitude = (route.query.longitude as string) || "";
    state.latitude = (route.query.latitude as string) || "";
    state.locationName = (route.query.title as string) || "";
    onMounted(() => {
      const { initMap } = useMap(state);
      initMap();
    });
    return {
      ...toRefs(state),
    };
  },
});

const useMap = (state: DataType) => {
  const initMap = () => {
    // 设置地图中心点
    let centerLoc = new TencentMap.LatLng(state.latitude, state.longitude);
    // 设置容器
    let map = new TencentMap.Map(document.getElementById("mapContainer"), {
      center: centerLoc,
    });
    // 在位置上添加信息
    let infoWindow = new TencentMap.InfoWindow({
      map,
      position: centerLoc,
      enableCustom: true,
      content: `<div style="min-width: 3rem;padding: 0.625rem;background:yellow;display:flex;font-size: 14px;
        border-radius:10px;
        position:relative;
        "><span>${state.locationName}</span>
        <div style="width: 0rem;height:0rem;position:absolute;bottom:-0.69rem;left:0;right:0;margin:0 auto;border-top: 0.7rem solid yellow;border-left: 0.6rem solid transparent; border-right: 0.6rem solid transparent;"></div>
        </div>`,
    });
    // map.setMinZoom(15);
    // map.setMaxZoom(18);
    map.setZoom(16);
    if (/(Android)/i.test(navigator.userAgent)) {
      map.setBaseMap({ type: "satellite" });
    } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      map.setBaseMap({ type: "vector" });
    }
  };
  return {
    initMap,
  };
};
